import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from './url-helper.service';
import { Response } from '../interfaces/response.interface';
import { AuthenticationService } from './authentication.serivce';

@Injectable()

export class CollectionDashboardService {

  organizationId: any;
  userId: any;

  constructor(private http: HttpClient, private urlHelper: UrlHelperService, private auth: AuthenticationService)
  {
    this.organizationId = auth.getSession()?.organizationId;
    this.userId = this.auth.getSession()?.userId;
  }

  getCollection(): Observable<Response> {
    var postData: { [k: string]: any } = {};
    postData['skip'] = 0;
    postData['take'] = 100;
    postData['organizationID'] = this.organizationId;
    postData['userId'] = this.userId
    postData['isActive'] = true;
    var url = this.urlHelper.getApiUrl() + "CollectionOrganization";
    return this.http.post<Response>(url, postData);
  }

}
